import React from "react";
import Menu from "./Menu";

const Container = ({ children, ...props }) => {
  return (
    <div>
      <Menu />
      {children}
    </div>
  );
};

export default Container;
